import { useDataChange } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let onActionSave = useDataOnActionSave(props, data)
  let onActionCancel = useDataOnActionCancel(props, data)

  return async function onSubmit({ value, change, args }) {
    switch (args?.type) {
      case 'save': {
        return onActionSave({ value })
      }
      case 'cancel': {
        return onActionCancel()
      }
      default: {
      }
    }
  }
}

/** @type {import('Simple/type.js').useDataOnSubmit} */
function useDataOnActionSave(props) {
  let change = useDataChange({
    context: 'appointment_overlay',
    viewPath: props.viewPath,
  })

  return async function onAction({ value }) {
    change(next => {
      next.note = value
      next.add_notes = value.length > 0
    })

    if (typeof props.closePopover === 'function') props.closePopover()
  }
}

/** @type {import('Simple/type.js').useDataOnSubmit} */
function useDataOnActionCancel(props) {
  return async function onAction() {
    if (typeof props.closePopover === 'function') props.closePopover()
  }
}
